const ConsignmentStatus = `
  id
  description
  updatedAt
`;

export default ConsignmentStatus;
